import script from "./ReferencesSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencesSearch.vue?vue&type=script&lang=ts&setup=true"

import "./ReferencesSearch.vue?vue&type=style&index=0&id=cb77dfa8&lang=scss"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QIcon,QTooltip,QItemSection});qInstall(script, 'directives', {Ripple});
